//#region libraries
import React from 'react';
import { Form, Pagination } from 'react-bootstrap';
//#endregion

export const PAGE_SIZES = [25, 50, 100, 200]; // the API caps limit at 200

// page numbers to show around the current page, with null for a gap:
// 1 … 4 5 [6] 7 8 … 40
const pageWindow = (current, count, spread = 2) => {
  const pages = [];
  const start = Math.max(2, current - spread);
  const end = Math.min(count - 1, current + spread);
  pages.push(1);
  if (start > 2) pages.push(null);
  for (let p = start; p <= end; p++) pages.push(p);
  if (end < count - 1) pages.push(null);
  if (count > 1) pages.push(count);
  return pages;
};

// Pager for the desk tables (passenger requests, lanyard orders). Pages are 1-based; the parent keeps skip.
const DeskPagination = ({ total, skip, pageSize, shown, disabled, onSkipChange, onPageSizeChange, noun = 'request' }) => {
  if (total === 0) return null;

  const pageCount = Math.max(1, Math.ceil(total / pageSize));
  const page = Math.min(pageCount, Math.floor(skip / pageSize) + 1);
  const goTo = (p) => onSkipChange((Math.min(Math.max(p, 1), pageCount) - 1) * pageSize);

  const first = skip + 1;
  const last = Math.min(skip + shown, total);

  return (
    <div style={styles.bar}>
      <span style={styles.small}>
        {`${first.toLocaleString('en-IE')}–${last.toLocaleString('en-IE')} of ${total.toLocaleString('en-IE')} ${noun}${total === 1 ? '' : 's'}`}
      </span>

      {pageCount > 1 ? (
        <Pagination size="sm" className="mb-0">
          <Pagination.First disabled={disabled || page === 1} onClick={() => goTo(1)} aria-label="First page" />
          <Pagination.Prev disabled={disabled || page === 1} onClick={() => goTo(page - 1)} aria-label="Previous page" />
          {pageWindow(page, pageCount).map((p, i) =>
            p === null ? (
              <Pagination.Ellipsis key={`gap-${i}`} disabled />
            ) : (
              <Pagination.Item
                key={p}
                active={p === page}
                disabled={disabled && p !== page}
                onClick={() => p !== page && goTo(p)}
                aria-label={`Page ${p}`}
              >
                {p}
              </Pagination.Item>
            )
          )}
          <Pagination.Next disabled={disabled || page === pageCount} onClick={() => goTo(page + 1)} aria-label="Next page" />
          <Pagination.Last disabled={disabled || page === pageCount} onClick={() => goTo(pageCount)} aria-label="Last page" />
        </Pagination>
      ) : null}

      <label style={styles.small}>
        Rows per page
        <Form.Select
          size="sm"
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          style={styles.select}
        >
          {PAGE_SIZES.map((size) => (
            <option key={size} value={size}>{size}</option>
          ))}
        </Form.Select>
      </label>
    </div>
  );
};

const styles = {
  bar: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    marginTop: 8,
    marginBottom: 8,
  },
  small: {
    fontSize: 12,
    opacity: 0.8,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginBottom: 0,
  },
  select: {
    width: 'auto',
  },
};

export default DeskPagination;
